(function () {
  var intro = document.querySelector('[data-blanc-logo-intro]');
  var storage;
  var storageTestKey = 'blancLogoIntroStorageTest';
  var sessionKey = 'blancLogoIntroSoftInkV2Seen';
  var fallbackTimer;
  var hasCompleted = false;
  var root = document.documentElement;

  function removeIntro() {
    root.classList.remove('blanc-logo-intro-pending');

    if (fallbackTimer) {
      window.clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }

    if (intro) {
      intro.removeEventListener('animationend', onAnimationEnd);
    }

    if (intro && intro.parentNode) {
      intro.parentNode.removeChild(intro);
    }
  }

  function completeIntro() {
    if (hasCompleted) {
      return;
    }

    hasCompleted = true;
    root.classList.remove('blanc-logo-intro-pending');
    root.classList.remove('blanc-logo-intro-active');
    root.classList.add('blanc-logo-intro-complete');
    removeIntro();
  }

  function onAnimationEnd(event) {
    if (event.target === intro) {
      completeIntro();
    }
  }

  if (!intro) {
    root.classList.remove('blanc-logo-intro-pending');
    return;
  }

  if (intro.getAttribute('data-page-type') !== 'index') {
    removeIntro();
    return;
  }

  if (window.Shopify && window.Shopify.designMode) {
    removeIntro();
    return;
  }

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    removeIntro();
    return;
  }

  try {
    storage = window.sessionStorage;
    storage.setItem(storageTestKey, '1');
    storage.removeItem(storageTestKey);
  } catch (error) {
    removeIntro();
    return;
  }

  if (storage.getItem(sessionKey)) {
    removeIntro();
    return;
  }

  try {
    storage.setItem(sessionKey, 'true');
  } catch (error) {
    removeIntro();
    return;
  }

  intro.addEventListener('animationend', onAnimationEnd);
  fallbackTimer = window.setTimeout(completeIntro, 2600);

  root.classList.remove('blanc-logo-intro-pending');
  root.classList.add('blanc-logo-intro-active');
  intro.hidden = false;
  intro.removeAttribute('hidden');

  window.requestAnimationFrame(function () {
    intro.classList.add('is-playing');
  });
})();
